import React from 'react'
import Tip from 'app/React/ProductForm/Tip'
import { useEnvValue } from '@morningtrain/react-helpers'

function VariationsHeightHeading(){
  const [chooseStr] = useEnvValue('strings.chooseHeight','Vælg')
  const [tooltipHeightStr] = useEnvValue('strings.tooltipHeight',null)
  return (
    <div className="mtt-variations__title">
      {chooseStr}
      {typeof tooltipHeightStr === 'string' && tooltipHeightStr.length > 0 ? <Tip>{tooltipHeightStr}</Tip> : null}
    </div>
  )
}

export default VariationsHeightHeading